import DatePicker from 'vue2-datepicker';
import appStrings from '@/app/utility/string.utility';
import commonHelper from '@/app/utility/common.helper.utility';
export default {
  name: 'editIsdRevenue',
  components: { DatePicker },
  props: ['rowData'],
  watch: {
    currentPage: function() {
      this.getIsdRevenueDataById();
    },
    perPage: function() {
      this.currentPage = 1;
      this.getIsdRevenueDataById();
    }
  },
  data() {
    return {
      financialYear: {
        text: null,
        value: null
      },
      legalEntity: {
        text: null,
        value: null
      },
      showValueSetModal: false,
      totalRows: null,
      currentPage: 1,
      perPage: commonHelper.perPageRecord,
      pageOptions: commonHelper.getPageOption(),
      editIsdRevenueData: [
        {
          gstn: null,
          revenue_amount: null
        }
      ],
      editIsdRevenueFields: [
        {
          key: 'gstn',
          label: 'GSTN Number',
          class: 'text-center'
        },
        {
          key: 'revenueAmount',
          label: 'Revenue Amount',
          class: 'text-center'
        },
        {
          key: 'distPercentage',
          label: 'Percentage of Distribution'
        },
        {
          key: 'add',
          stickyColumn: true,
          class: 'text-center'
        },
        {
          key: 'remove',
          stickyColumn: true,
          class: 'text-center'
        }
      ],
      freezeFlag: false,
      editMode: false,
      specIndex: null,
      parent_value_set_id: null,
      setTimeVsetCode: null,
      loader: false
    };
  },
  mounted() {
    this.legalEntity.text = this.rowData.OrgName;
    this.legalEntity.value = this.rowData.leId;
    this.financialYear.text = this.rowData.finYear;
    this.freezeFlag = this.rowData.freezeFlag;
    this.getIsdRevenueDataById();
    this.unsubscribe = this.$store.subscribe((mutation, state) => {
      if (mutation.type === 'shared/setActionName') {
        const actionName = state.shared.actionName;
        if (actionName === 'save') {
          this.postIsdRevenueData();
        }
        if (actionName === 'update') {
          this.editMode = true;
        }
      }
    });
  },
  methods: {
    openValueSetModal(vsetCode, index) {
      this.specIndex = index;
      this.vsetCode = vsetCode;
      this.showValueSetModal = true;
      if (this.vsetCode === appStrings.VALUESETTYPE.GST_REGULAR_GSTN_VS) {
        this.parent_value_set_id = this.legalEntity.value;
      }
      this.setTimeVsetCode = setTimeout(() => {
        const vSetData = {
          valueSetName: vsetCode,
          multiFlag: null
        };
        this.eventBus.$emit('valueSetCode', vSetData);
      }, 0);
    },
    selectedvalueSet(item) {
      if (this.vsetCode === appStrings.VALUESETTYPE.LEGAL_ENTITY_LIST) {
        this.legalEntity = {
          text: item.value_code,
          value: item.value_set_dtl_id
        };
      } else if (this.vsetCode === appStrings.VALUESETTYPE.CUSTOM_FY) {
        this.financialYear = {
          text: item.value_meaning,
          value: item.value_code
        };
      } else if (
        this.vsetCode === appStrings.VALUESETTYPE.GST_REGULAR_GSTN_VS
      ) {
        const filterGstn = this.editIsdRevenueData.filter(
          ele => ele.gstn == item.gst_number
        );
        if (filterGstn.length === 0) {
          this.editIsdRevenueData[this.specIndex].gstn = item.gst_number;
        } else {
          alert('Already GSTN Exist');
        }
      }
      this.editIsdRevenueData = JSON.parse(
        JSON.stringify(this.editIsdRevenueData)
      );
    },
    closeValueSetModal() {
      this.showValueSetModal = false;
    },
    clearVsetValues(vsetCode) {
      if (vsetCode === 'LEGAL_ENTITY_LIST') {
        this.legalEntity = {
          text: null,
          value: null
        };
      } else if (vsetCode === 'CUSTOM_FY') {
        this.financialYear = {
          text: null,
          value: null
        };
      } else if (vsetCode === 'GST_REGULAR_GSTN_VS') {
        this.this.editIsdRevenueData[this.specIndex].gstn = null;
      }
    },
    addNewRow() {
      this.editIsdRevenueData.push({
        gstn: null,
        revenue_amount: null
      });
    },
    removeRow(index) {
      this.editIsdRevenueData.splice(index, 1);
    },
    postIsdRevenueData() {
      let isdRevenueData = [];
      isdRevenueData = this.editIsdRevenueData.map(item => {
        return {
          gstn_no: item.gstn,
          revenue_amount: Number(item.revenueAmount)
        };
      });

      const payload = {
        le_id: this.rowData.leId,
        fin_year: this.rowData.finYear,
        page: isdRevenueData
      };
      this.loader = true;
      this.$store
        .dispatch('isdRevenue/postIsdRevenueData', payload)
        .then(response => {
          this.loader = false;
          if (response.status === 200) {
            this.editMode = false;
            this.$bvToast.toast(response.data.message, {
              title: 'Alert',
              variant: 'success',
              solid: true
            });
            this.getIsdRevenueDataById();
          } else {
            this.loader = false;
            let message2 = response.response.data['page[4].gstnNo'];
            this.$bvToast.toast(response.response.data.message, {
              title: 'Alert',
              variant: 'danger',
              solid: true
            });
            this.$bvToast.toast(message2, {
              title: 'Alert',
              variant: 'danger',
              solid: true
            });
          }
        })
        .catch(err => {
          this.err = err;
          this.loader = false;
        });
    },
    getIsdRevenueDataById() {
      const payload = {
        _page: this.currentPage - 1,
        _limit: this.perPage,
        fin_year: this.rowData.finYear,
        le_id: this.rowData.leId
      };
      this.loader = true;
      this.$store
        .dispatch('isdRevenue/getIsdRevenueDataById', payload)
        .then(response => {
          this.loader = false;
          if (response.status === 200) {
            this.editIsdRevenueData = response.data.data.pageData.page;
            this.totalRows = response.data.data.pageData.total_elements;
            this.editIsdRevenueData.map(data => {
              data.freezeFlag = data.freezeFlag === 'Y' ? true : false;
              return data;
            });
            if (this.editIsdRevenueData.length == 0) {
              this.editIsdRevenueData.push({
                gstn: null,
                revenue_amount: null
              });
            }
          }
        })
        .catch(() => {
          this.loader = false;
        });
    }
  },
  beforeDestroy() {
    this.unsubscribe();
  }
};
